import createIcon from '../../createIcon';

/**
 * @component @name DriveEta
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguOTIgNS4wMUMxOC43MiA0LjQyIDE4LjE2IDQgMTcuNSA0SDYuNUM1Ljg0IDQgNS4yOSA0LjQyIDUuMDggNS4wMUwzIDExVjE5QzMgMTkuNTUgMy40NSAyMCA0IDIwSDVDNS41NSAyMCA2IDE5LjU1IDYgMTlWMThIMThWMTlDMTggMTkuNTUgMTguNDUgMjAgMTkgMjBIMjBDMjAuNTUgMjAgMjEgMTkuNTUgMjEgMTlWMTFMMTguOTIgNS4wMVpNNi41IDE1QzUuNjcgMTUgNSAxNC4zMyA1IDEzLjVDNSAxMi42NyA1LjY3IDEyIDYuNSAxMkM3LjMzIDEyIDggMTIuNjcgOCAxMy41QzggMTQuMzMgNy4zMyAxNSA2LjUgMTVaTTE3LjUgMTVDMTYuNjcgMTUgMTYgMTQuMzMgMTYgMTMuNUMxNiAxMi42NyAxNi42NyAxMiAxNy41IDEyQzE4LjMzIDEyIDE5IDEyLjY3IDE5IDEzLjVDMTkgMTQuMzMgMTguMzMgMTUgMTcuNSAxNVpNNSAxMEw2LjUgNS41SDE3LjVMMTkgMTBINVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DriveEta = createIcon('DriveEta', [
  [
    'path',
    {
      d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3 11V19C3 19.55 3.45 20 4 20H5C5.55 20 6 19.55 6 19V18H18V19C18 19.55 18.45 20 19 20H20C20.55 20 21 19.55 21 19V11L18.92 5.01ZM6.5 15C5.67 15 5 14.33 5 13.5C5 12.67 5.67 12 6.5 12C7.33 12 8 12.67 8 13.5C8 14.33 7.33 15 6.5 15ZM17.5 15C16.67 15 16 14.33 16 13.5C16 12.67 16.67 12 17.5 12C18.33 12 19 12.67 19 13.5C19 14.33 18.33 15 17.5 15ZM5 10L6.5 5.5H17.5L19 10H5Z',
      key: 'ulk4p3',
    },
  ],
]);

export default DriveEta;
